import { createSlice } from "@reduxjs/toolkit";
import {
  deleteUnits,
  editUnits,
  // getUnitsById,
  // getUnitsList,
  getUnitsPage,
  postUnits,
  // getUnitsByRegionalId,
} from "../action/unitsAction";

const initialState = {
  dataUnits: [],
  dataByIdUnits: [],
  dataUnitsByRegionalId: [],
  idUnits: "",
  state: "",
  isOpenForm: false,
  isLoading: false,
};
const unitsSlice = createSlice({
  name: "units",
  initialState,
  reducers: {
    openForm: (state, action) => {
      state.isOpenForm = action.payload.open;
      state.state = action.payload.state;
      if (action.payload.type === 'close') {
        state.dataByIdUnits = []
        state.idUnits = ''
      }
      if (action.payload.state === "edit") {
        state.dataByIdUnits = action.payload.data;
        state.idUnits = action.payload.id;
      } else if (action.payload.state === "delete") {
        state.dataByIdUnits = action.payload.data;
        state.idUnits = action.payload.id;
      }
    },
  },
  extraReducers: {
    [getUnitsPage.pending]: (state) => {
      state.isLoading = true;
    },
    [getUnitsPage.fulfilled]: (state, action) => {
      // console.log(action.payload);
      state.dataUnits = action.payload.data;
      state.isLoading = false;
    },
    [getUnitsPage.rejected]: (state) => {
      state.isLoading = false;
    },
    [postUnits.pending]: (state) => {
      state.isLoading = true;
    },
    [postUnits.fulfilled]: (state, action) => {
      // console.log(action.payload);
      state.isOpenForm = false;
      state.isLoading = false;
    },
    [postUnits.rejected]: (state) => {
      state.isLoading = false;
    },
    [editUnits.pending]: (state) => {
      state.isLoading = true;
    },
    [editUnits.fulfilled]: (state, action) => {
      state.isOpenForm = false;
      state.isLoading = false;
      state.dataByIdUnits = [];
      state.idUnits = 0;
    },
    [editUnits.rejected]: (state) => {
      state.isLoading = false;
    },
    [deleteUnits.pending]: (state) => {
      state.isLoading = true;
    },
    [deleteUnits.fulfilled]: (state, action) => {
      state.isOpenForm = false;
      state.isLoading = false;
      state.dataByIdUnits = [];
      state.idUnits = 0;
    },
    [deleteUnits.rejected]: (state) => {
      state.isLoading = false;
    },
  },
});

export const { openForm } = unitsSlice.actions;
export default unitsSlice.reducer;
